import axios from "axios";
import UrlAssembler from "url-assembler";

type AzureAdAppRegistration = {
  tenantName: string,
  clientId: string,
}

type AzureAdGroup = {
  Id: string,
  Name: string,
}

interface IEmployeeAzureAdConfig extends AzureAdAppRegistration {
    roles: {
    user: string,
    admin: string
  },
  groups: AzureAdGroup[],
}
interface ICustomerAzureB2CConfig extends AzureAdAppRegistration {
  loginDomain?: string;
  scopes: string[],
  policies: {
    login: string;
  }
}

interface IAzureAdSettings {
  logMsalEvents?: boolean,
  employeeAD: IEmployeeAzureAdConfig;
  customerAzureB2C: ICustomerAzureB2CConfig;
}

type IAppConfigJson = {
  name: string;
  dataUrl: string;
  buildVersion: string;
  useLocalTemplateJson: boolean;
  localeId: number | undefined;
  authentication: IAzureAdSettings
};

export interface IAppConfig {
  readonly name: string;
  readonly apiUrl: UrlAssembler;
  readonly oDataUrl: UrlAssembler;
  readonly useLocalTemplateJson: boolean;
  readonly buildVersion: string;
  readonly localeId: number | undefined;
  readonly authentication: Readonly<IAzureAdSettings> & { logMsalEvents: boolean }
}

//type IAppConfigJson = Record<keyof IAppConfig | "dataUrl", string> & { useLocalTemplateJson: boolean };

export class AppConfig implements IAppConfig {
  readonly name: string;
  readonly apiUrl: UrlAssembler;
  readonly oDataUrl: UrlAssembler;
  readonly useLocalTemplateJson: boolean;
  readonly buildVersion: string;
  readonly localeId: number | undefined;
  readonly authentication: Readonly<IAzureAdSettings> & { logMsalEvents: boolean }

  constructor(json: IAppConfigJson) {
    console.assert(json.name);
    this.name = json.name;
    this.apiUrl = new UrlAssembler(json.dataUrl).segment("api/");
    this.oDataUrl = new UrlAssembler(json.dataUrl).segment("odata/");
    this.useLocalTemplateJson = json.useLocalTemplateJson === true;
    this.buildVersion = json.buildVersion;
    this.localeId = json.localeId;
    const logMsalEvents = !!json.authentication.logMsalEvents;
    this.authentication = { ...json.authentication, logMsalEvents };
    if (!this.authentication.customerAzureB2C.loginDomain)
      this.authentication.customerAzureB2C.loginDomain = `${this.authentication.customerAzureB2C.tenantName}.b2clogin.com`;
  }
}

let loadedConfig: IAppConfig;

// Load config file from "/public/config.json"
const configFileName = "config.json";
const configUrl = process.env.PUBLIC_URL + "/" + configFileName;

async function internalLoadConfig() {
  try {
    const configResponse = await axios.get<IAppConfigJson>(configUrl);
    loadedConfig = new AppConfig(configResponse.data);
    return loadedConfig;
  }
  catch (e) {
      throw new Error(`Failed to load app configuration (${configFileName})`);
  }
}


const configLoaderPromise = internalLoadConfig();
// The following isn't strictly needed -- we could just export `cachedConfigLoader` directly.
// However, making it a function makes for a better API. Ex: Instead of `loadConfig.then(...)`, caller will need to use `loadConfig().then(...)`
const loadConfig = () => configLoaderPromise;


function getLoadedConfig() {
  if (!loadedConfig) {
    throw new Error("App Configuration hasn't been loaded!")
  }

  return loadedConfig;
}

export { loadedConfig as default, loadConfig, getLoadedConfig };




